export enum Sidebar {
    Tips = 'tips',
    Help = 'help',
    FilterPanel = 'filter',
}